import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(constants.AUTO_CREATE_MGD_UPLOAD_FILE.SUCCESS, saga.uploadFileSuccess);
    yield takeLatest(constants.AUTO_CREATE_MGD_UPLOAD_FILE.FAILED, saga.uploadFileFailed);
}
